import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "../../../theme";
import { Icon } from "../../../icon";
export const ClearFieldButton = ({ onClick }) => (_jsx(Wrapper, { onClick: onClick, children: _jsx(CloseIcon, { name: "close" }) }));
const CloseIcon = styled(Icon) `
  display: grid;
  color: ${({ theme }) => theme.color.white};
  font-size: 0.65em;
`;
const Wrapper = styled.div `
  display: grid;
  place-items: center;
  min-width: 1.2em;
  min-height: 1.2em;
  width: 1.2em;
  height: 1.2em;
  position: relative;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.darkBlue30};
`;
